// extracted by css-extract-rspack-plugin
export default {"root":"bRLREu","button":"GYyMKP","header":"FPtzvi","subheader":"XtRnYn"};